import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/domains/about/images/raypoynter.webp");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/domains/about/images/willpoynter.webp");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/home/will/Documents/Business/wise/repos/wise/site/themes/catalyst/link.tsx");
